import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ProductsService } from '../services/products.service';
import { Storage } from '@ionic/storage';
import * as i0 from "@angular/core";
import * as i1 from "@ionic/storage";
import * as i2 from "../services/products.service";
import * as i3 from "@angular/router";
export class ShoppingCartGuard {
    constructor(storage, productsService, router) {
        this.storage = storage;
        this.productsService = productsService;
        this.router = router;
        this.loader$ = new Subject();
        this.loader = false;
        this.loader$.pipe(debounceTime(300)).subscribe(loader => { this.loader = loader; });
    }
    loadOrder() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.productsService.order = yield this.storage.get('order');
            this.productsService.buyed_cart = this.productsService.order.cart_products;
            this.productsService.shopping_cart_valid = true;
            this.productsService.epayco_status_code = yield this.storage.get('epayco_status_code');
        });
    }
    canActivate() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (window.location.href.includes('epayco')) {
                yield this.loadOrder();
            }
            this.setShowLoader(true);
            if (this.productsService.shopping_cart_valid || this.productsService.reward_mission || this.productsService.buyed_cart) {
                this.setShowLoader(false);
                return true;
            }
            this.router.navigateByUrl('/carrito-de-compras');
            return false;
        });
    }
    setShowLoader(show) {
        this.loader$.next(show);
    }
}
ShoppingCartGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ShoppingCartGuard_Factory() { return new ShoppingCartGuard(i0.ɵɵinject(i1.Storage), i0.ɵɵinject(i2.ProductsService), i0.ɵɵinject(i3.Router)); }, token: ShoppingCartGuard, providedIn: "root" });
